import { getNotificationsCount } from '@/fsd/entities/notifications/api/getNotificationCount/getNotificationCount';
import { NOTIFICATION_STATUSES } from '@/fsd/entities/notifications/model/consts/consts';
import { Button } from '@/fsd/shared/ui';
import EmptyData from '@/fsd/shared/ui/EmptyData/EmptyData';
import CustomPopover from '@/fsd/shared/ui/Popover/Popover';
import TabsRoot from '@/fsd/shared/ui/Tabs/Tabs';
import { CheckCheckIcon, NotificationIcon } from '@/fsd/shared/ui/icons';
import { useQuery } from '@tanstack/react-query';
import cx from 'classnames';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useAllNotificationsList } from '../../model/hooks/useAllNotificationsList'; // Import useAllNotificationsList
import AllNotificationsList from '../AllNotificationsList/AllNotificationsList';
import { CheckButton } from '../CheckButton/CheckButton';
import styles from './Notifications.module.scss';
import './Notifications.scss';

const Notifications = observer(() => {
  const { data } = useQuery({
    queryKey: ['notification-count'],
    queryFn: getNotificationsCount,
  });

  const hasUnreadNotifications = useMemo(
    () => data?.data.new && data?.data.new > 0,
    [data?.data.new]
  );

  return (
    <CustomPopover
      anchorElement={
        <NotificationIcon
          hasUnreadNotifications={Boolean(hasUnreadNotifications)}
        />
      }
      className={styles.popover}
    >
      <div className={cx(styles.container, 'notifications')}>
        <h3 className={styles.title}>Уведомления</h3>
        <ErrorBoundary
          fallbackRender={() => (
            <EmptyData desc="Произошла ошибка при загрузке уведомлений." />
          )}
        >
          <TabsRoot className={styles.tabsRoot} defaultValue={0}>
            <div className={styles.tabsHeader}>
              <TabsRoot.TabList className={styles.tabList}>
                <TabsRoot.Tab className={styles.tab}>Новые</TabsRoot.Tab>
                <TabsRoot.Tab className={styles.tab}>Прочитанные</TabsRoot.Tab>
              </TabsRoot.TabList>
              <CheckButton />
            </div>

            <TabsRoot.TabPanel className={styles.tabPanel} value={0}>
              <AllNotificationsList status={NOTIFICATION_STATUSES.NEW} />
            </TabsRoot.TabPanel>
            <TabsRoot.TabPanel className={styles.tabPanel} value={1}>
              <AllNotificationsList status={NOTIFICATION_STATUSES.READ} />
            </TabsRoot.TabPanel>
          </TabsRoot>
        </ErrorBoundary>
      </div>
    </CustomPopover>
  );
});

export default Notifications;
